<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="代理人id">-->
<!--                  <el-input  v-model="queryForm.gradeId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="合伙人">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 200px;" labelName="userName" title="选择用户"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="分红比例">-->
<!--                  <el-input  v-model="queryForm.radio"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppGradeTeamList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppGradeTeam"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editMppGradeTeam(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppGradeTeam(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppGradeTeamList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppGradeTeamList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="id"-->
<!--        label=""-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="gradeId"-->
<!--        label="代理人id"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="合伙人"
        min-width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.mppUser">
                  <div style="text-align: left">账号：{{ scope.row.mppUser.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.mppUser.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.mppUser.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.mppUser.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="radio"
        label="分红比例"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppGradeTeam(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editMppGradeTeam(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteMppGradeTeam(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppGradeTeamStates[mppGradeTeamState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="mppGradeTeam"
          ref="mppGradeTeamForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="代理人id"-->
<!--            prop="gradeId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppGradeTeam.gradeId"-->
<!--              :disabled="mppGradeTeamState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="合伙人"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="mppGradeTeam.userId"-->
<!--              :disabled="mppGradeTeamState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 200px;" labelName="userName" :disabled="mppGradeTeamState == 'check'" title="选择用户"
                           labelValue="id" :value="mppGradeTeam.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="分红比例"
            prop="radio"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mppGradeTeam.radio"
              :disabled="mppGradeTeamState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppGradeTeamState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppGradeTeamList();
                    this.getMppGradeTeamList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppGradeTeamList();
                    this.getMppGradeTeamList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     gradeId: '', //代理人id
                     userId: '', //合伙人
                     radio: '', //分红比例
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppGradeTeamState: 'add',
                mppGradeTeamStates: {
                    add: '新建合伙人',
                    check: '查看合伙人',
                    edit: '修改合伙人'
                },

                multipleSelection: [],
                mppGradeTeamList: [],
                mppGradeTeam: {
                    id: '', //
                    gradeId: '', //代理人id
                    userId: '', //合伙人
                    radio: '', //分红比例
                },
                btnLoading: false,

                rules: {
                    gradeId: [{ required: true, message: '代理人id不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '合伙人不能为空', trigger: 'blur' }],
                    radio: [{ required: true, message: '分红比例不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {

        },
        methods: {
            init(id){
                this.mppGradeTeam.gradeId = id;
                this.queryForm.gradeId = id;
                this.getMppGradeTeamList();
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser(value) {
                this.mppGradeTeam.userId = value
            },
            getSeachValueUser(value){
                this.queryForm.userId = value
            },
            resetMppGradeTeamList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppGradeTeamList = [];
            },
            resetDialog() {
                this.mppGradeTeamState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      gradeId: this.queryForm.gradeId, //代理人id
                      userId: '', //合伙人
                      radio: '', //分红比例
                };
                this.getMppGradeTeamList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppGradeTeam = {
                      id: '', //
                      gradeId: this.mppGradeTeam.gradeId, //代理人id
                      userId: '', //合伙人
                      radio: '', //分红比例
                };
            },
            submitForm() {
                if (this.mppGradeTeamState == 'add') {
                    this.$refs.mppGradeTeamForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/gradeteam/add`,{ ...this.mppGradeTeam }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppGradeTeamList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppGradeTeamState == 'edit') {
                    this.$refs.mppGradeTeamForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/gradeteam/edit`,{ ...this.mppGradeTeam }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppGradeTeamList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppGradeTeam() {
                this.showDialog = true;
                this.mppGradeTeamState = 'add';
            },
            checkMppGradeTeam(mppGradeTeamId) {
                console.log(mppGradeTeamId);
                this.currentMppGradeTeamId = mppGradeTeamId;

                this.getMppGradeTeamById();
                this.showDialog = true;
                this.mppGradeTeamState = 'check';
            },
            editMppGradeTeam(mppGradeTeamId) {
                console.log('mppGradeTeam', mppGradeTeamId);
                if (mppGradeTeamId) {
                    this.currentMppGradeTeamId = mppGradeTeamId;
                    this.getMppGradeTeamById();
                } else {
                    this.mppGradeTeam = { ...this.mppGradeTeam, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppGradeTeamState = 'edit';
            },
            deleteMppGradeTeam(mppGradeTeamId) {
                let ids = '';
                if (mppGradeTeamId) {
                    ids = mppGradeTeamId;
                } else {
                    ids = this.multipleSelection.map((mppGradeTeam) => mppGradeTeam.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/gradeteam/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGradeTeamList();
                                this.getMppGradeTeamList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppGradeTeamList() {
                this.resetMppGradeTeamList();
                this.getMppGradeTeamList();
            },
            getMppGradeTeamList(query = {}) {
                this.loading = true;
                get(`/mpp/gradeteam/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppGradeTeamList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppGradeTeamById() {
                get(`/mpp/gradeteam/get`,{ id: this.currentMppGradeTeamId }).then((res) =>{
                    if(res.success){
                      this.mppGradeTeam = { ...this.mppGradeTeam, ...res.mppGradeTeam };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppGradeTeamList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/gradeteam/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/gradeteam/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/gradeteam/importData`,formData);
              this.refreshMppGradeTeamList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppGradeTeamList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppGradeTeamList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>